const path = {
  join: function () {
    const args = Array.prototype.slice.call(arguments)

    return args.join('/').replace('//', '/')
  },
}

export default path
